import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  TrialDialogData,
  TrialDialogService,
} from '@pyg-services/trial-dialog.service';
import { LanguageService } from '@pyg-services/language/language.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ClickOutsideDirective } from '@pyg-directives/click-outside.directive';
import { FormsService } from '@pyg-services/forms/forms.service';
import { FORM_TYPE } from '@pyg-services/forms/forms.constants';
import { FormTypeEnum } from '@pyg-services/forms/forms.types';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-free-trial',
  templateUrl: './free-trial.component.html',
  styleUrls: ['./free-trial.component.scss'],
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    LangRouterLink,
    NgTemplateOutlet,
    ClickOutsideDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: FORM_TYPE, useValue: FormTypeEnum.FREE_TRIAL },
    FormsService,
  ],
})
export class FreeTrialComponent {
  private readonly trialDialog = inject(TrialDialogService);
  private readonly langService = inject(LanguageService);
  private readonly formsService =
    inject<FormsService<FormTypeEnum.FREE_TRIAL>>(FormsService);

  public readonly tel = this.langService.langTelNum;
  public readonly status = this.formsService.requestStatus;
  public readonly demoForm = this.formsService.form;

  readonly freeTrialData = input.required<TrialDialogData>();
  readonly isDialog = input<boolean>();

  public onCloseDialog() {
    this.trialDialog.closeDialog();
    this.formsService.resetStatus();
  }

  public sendRequest() {
    const { place, isMuseum } = this.freeTrialData();
    this.formsService.submit(place, isMuseum);
  }

  public outsideForm() {
    this.demoForm.markAsUntouched();
  }

  public resetStatus() {
    this.formsService.resetStatus();
  }
}
